<template>
  <a-modal title="选择关联资源" :visible="visible" width="65%" @cancel="handleCancel" :confirm-loading="confirmLoading">
    <div style="max-height: 500px; overflow: auto" class="select-modal">
      <div>
        <a-row style="margin-bottom: 10px">
          <a-breadcrumb v-if="breadcrumbList.length > 1">
            <a-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="item.id">
              <span class="link" @click="handleBreadcrumb(index, item)">{{ item.name }}</span>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </a-row>
        <a-table
          :columns="gradeColumns"
          :rowSelection="rowSelection"
          :pagination="gradeTableRelevant.tablePagination"
          row-key="id"
          :loading="gradeTableRelevant.tableLoading"
          :data-source="gradeTableRelevant.tableDataSource"
          :key="tableKey"
        >
          <div slot="name" class="table-name" slot-scope="text">
            <img :src="$getFileType(text.fileType).icon" style="width: 15px; height: 15px" />
            <a @click="nextFolder(text)" v-if="!text.fileType">{{ text.name }} </a>
            <span v-else :title="text.name">{{ text.name + suffix(text.fileName, 1) }}</span>
          </div>
          <div slot="type" slot-scope="text">
            {{ searchFileType[text.fileType] }}
            {{ text.fileType === 1 ? `（${suffix(text.fileName)}）` : '' }}
          </div>
          <div slot="size" slot-scope="text">
            {{ text.size > 1024 * 1024 ? (text.size / (1024 * 1024)).toFixed(2) + 'M' : text.size / 1024 < 1 ? (text.size ? text.size + 'B' : '--') : (text.size / 1024).toFixed(2) + 'KB' }}
          </div>
        </a-table>
      </div>
    </div>
    <div slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk" :disabled="selectedRowKeys.length === 0">确认</a-button>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { FileResource } from '@/utils/http'
export default {
  name: 'SelectSource',
  props: {
    select: {
      type: [Array],
      default: [],
    },
    exclude: {
      type: [Array],
      default: [],
    },
  },
  watch: {
    selectedRowKeys() {
      this.tableKey += 1
    },
  },
  computed: {
    rowSelection() {
      return {
        onSelect: (record, selected) => {
          if (selected) {
            this.selectedRowKeys.push(record.id)
            this.selectRow.push(record)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => v != record.id)
            this.selectRow = this.selectRow.filter((v) => v.id != record.id)
          }
        },
        onSelectAll: () => false,
        hideDefaultSelections: true,
        getCheckboxProps: (record) => {
          const dis = this.selectedRowKeys.length >= this.maxLen && !this.selectedRowKeys.includes(record.id)
          return {
            props: {
              disabled: record.fileType == 0 ||this.exclude.includes(+record.fileType)|| dis || this.select.some(s => s.fileResourceId === record.id),
            },
          }
        },
        selectedRowKeys: this.selectedRowKeys,
      }
    },
  },
  data() {
    return {
      tableKey: 1,
      maxLen: 5,
      breadcrumbList: [
        {
          name: '资源中心',
          id: undefined,
        },
      ],
      searchFileType: ['文件夹', '文档 ', '图片', '音频', '视频', '压缩文件'],
      gradeTableRelevant: tableRelevant.call(this),
      gradeColumns: [
        {
          title: '资源标题',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '类型',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '大小',
          scopedSlots: { customRender: 'size' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
        },
        {
          title: '上传时间',
          dataIndex: 'uploadTime',
        },
      ],
      selectedRowKeys: [],
      selectRow: [],
      searchForm: {},
      visible: false,
      confirmLoading: false,
    }
  },
  created() {},
  methods: {
    showModal(params = {}, select) {
      return new Promise((resolve, reject) => {
        this.visible = true
        this._resolve = resolve
        this._reject = reject
        this._params = params
        this.maxLen = 5 - this.select.length
        this.getPageList(1)
      })
    },
    handleOk() {
      this.visible = false
      this._resolve && this._resolve({ keys: [...this.selectedRowKeys], rows: [...this.selectRow] })
      this.selectRow = []
      this.selectedRowKeys = []
    },
    handleCancel() {
      this.visible = false
      this._reject && this._reject()
      this.selectRow = []
      this.selectedRowKeys = []
      this.breadcrumbList = this.breadcrumbList.slice(0, 1)
    },
    getPageList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.gradeTableRelevant.tablePagination.current,
        pageSize: this.gradeTableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        childCourseId: this._params.childCourseId,
      }
      if (this.breadcrumbList.length) {
        params.id = this.breadcrumbList.slice(-1)[0].id
      }
      this.gradeTableRelevant.tableLoading = true
      FileResource.pagelist(params).then((res) => {
        this.gradeTableRelevant.tableDataSource = res.data.items
        this.gradeTableRelevant.tablePagination.total = res.data.totalCount
        this.gradeTableRelevant.tablePagination.current = res.data.pageIndex
      }).finally(() => {
        this.gradeTableRelevant.tableLoading = false
      })
    },
    nextFolder(record) {
      this.breadcrumbList.push({
        id: record.id,
        name: record.name,
      })
      this.getPageList(1)
    },
    handleBreadcrumb(index, record) {
      this.breadcrumbList = this.breadcrumbList.slice(0, index + 1)
      this.getPageList(1)
    },
    suffix(str, point) {
      if (point) {
        return str.substring(str.lastIndexOf('.')).toLowerCase()
      }
      return str.substring(str.lastIndexOf('.') + 1).toLowerCase()
    },
  },
}
</script>
<style lang="less" scoped>
.table-name {
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
}
.link {
  cursor: pointer;
}
.select-modal {
  ::v-deep .ant-table-pagination.ant-pagination {
    // float:left;
  }
  ::v-deep .ant-table-thead .ant-table-selection-column .ant-table-header-column {
    display: none;
  }
}
</style>
